<template>
  <WdsAlert :error="!compliance.completed" :data-test="`compliance-status-${compliance.name}`">
    <WdsStack gap-sm align-center class="tw-flex-wrap lg:tw-flex-nowrap tw-justify-between">
      <WdsStack gap-sm align-start class="tw-flex-1">
        <WdsStack align-start>
          <WdsIcon :name="WdsIconNameEnum.WARNING" :size="20" weight="thin" class="tw-mt-0.5" />
        </WdsStack>

        <WdsStack direction-column>
          <WdsText large>
            <span class="tw-text-red-600">{{ title }}</span>
          </WdsText>

          <WdsText>
            <span class="tw-text-gray-800"
              >{{ descriptionBeforeLink }}<a
                v-if="existingContractUrl"
                :href="existingContractUrl"
                class="tw-underline"
                >{{ linkText }}</a
              ><template v-else>{{ linkText }}</template
              >{{ descriptionAfterLink }}</span
            >
          </WdsText>
        </WdsStack>
      </WdsStack>

      <HireComplianceAction
        v-if="!!compliance.action"
        :action="compliance.action"
        :hire-id="hireId"
        :compliance-name="compliance.name"
      />
    </WdsStack>
  </WdsAlert>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsAlert, WdsIcon, WdsIconNameEnum, WdsStack, WdsText } from '@worksome/wds-components'
import HireComplianceAction from '@/components/Hire/HirePageCompliance/HireComplianceAction.vue'
import { useFragment } from '@/gql'
import { ComplianceActionAlertButtonFragmentDoc, ComplianceAlertFragment } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const props = defineProps<{
  compliance: ComplianceAlertFragment
  hireId: string
}>()

const title = computed(() => $t('Contract cannot be accepted'))

const descriptionBeforeLink = computed(() =>
  $t('You already have an '),
)
const linkText = computed(() => $t('existing contract'))
const descriptionAfterLink = computed(() =>
  $t(
    ' with this client for an overlapping period. Ask your client to adjust the contract dates so they no longer overlap.',
  ),
)

const existingContractUrl = computed(() =>
  props.compliance.action
    ? useFragment(ComplianceActionAlertButtonFragmentDoc, props.compliance.action).action
    : null,
)
</script>
